// src/context/SeasonContext.js
import React, { createContext, useContext } from "react";

const SeasonContext = createContext(null);

const SEASONS = [
  {
    id: "hurricane",
    label: "Hurricane Season",
    startMonthDay: "06-01",
    endMonthDay: "11-30",
    hazardKey: "Hurricane",
    isPrimary: true,
  },
  {
    id: "wildfire",
    label: "Wildfire Season",
    startMonthDay: "02-15",
    endMonthDay: "10-31",
    hazardKey: "Wildfire",
  },
  {
    id: "winterWeather",
    label: "Winter Weather Season",
    startMonthDay: "11-01",
    endMonthDay: "03-31",
    hazardKey: "Winter Weather",
  },
  {
    id: "severeStorms",
    label: "Severe Storms & Tornado Season",
    startMonthDay: "03-01",
    endMonthDay: "06-30",
    hazardKey: "Severe Storms",
    isPrimary: true,
  },
  {
    id: "flooding",
    label: "Flooding Season",
    startMonthDay: "03-01",
    endMonthDay: "07-31",
    hazardKey: "Flooding",
  },
  // {
  //   id: "extremeCold",
  //   label: "Extreme Cold Season",
  //   startMonthDay: "11-01",
  //   endMonthDay: "03-15",
  //   hazardKey: "Extreme Cold",
  // },
  // {
  //   id: "fog",
  //   label: "Dense Fog Season",
  //   startMonthDay: "11-01",
  //   endMonthDay: "03-31",
  //   hazardKey: "Dense Fog",
  // },
  // {
  //   id: "highWinds",
  //   label: "High Winds Season",
  //   startMonthDay: "11-01",
  //   endMonthDay: "04-30",
  //   hazardKey: "High Winds",
  // },
  {
    id: "surfRip",
    label: "Surf & Rip Current Season",
    startMonthDay: "05-01",
    endMonthDay: "09-30",
    hazardKey: "Surf & Rip Currents",
  },
];

const mdToNumber = (monthDay) => {
  const [m, d] = monthDay.split("-").map((n) => parseInt(n, 10));
  // e.g. 11-01 -> 1101, 03-31 -> 331
  return m * 100 + d;
};

const isInRange = (today, startMonthDay, endMonthDay) => {
  const m = today.getMonth() + 1; // 1–12
  const d = today.getDate();
  const todayNum = m * 100 + d;

  const startNum = mdToNumber(startMonthDay);
  const endNum = mdToNumber(endMonthDay);

  // Non wrap-around (e.g., Mar–Jul)
  if (startNum <= endNum) {
    return todayNum >= startNum && todayNum <= endNum;
  }

  // Wrap-around season (e.g., Nov–Mar)
  return todayNum >= startNum || todayNum <= endNum;
};

export const SeasonProvider = ({ children }) => {
  const now = new Date();
  const today = new Date(
    now.getFullYear(),
    now.getMonth(),
    now.getDate(),
    12,
    0,
    0,
    0
  );

  const currentSeasons = SEASONS.filter((s) =>
    isInRange(today, s.startMonthDay, s.endMonthDay)
  );

  console.log(
    "[SeasonContext] today (local noon):",
    today.toISOString(),
    "md:",
    (today.getMonth() + 1) * 100 + today.getDate(),
    "currentSeasons:",
    currentSeasons.map((s) => s.id)
  );

  const value = {
    seasons: SEASONS,
    currentSeasons,
    upcomingSeasons: [],
  };

  return (
    <SeasonContext.Provider value={value}>
      {children}
    </SeasonContext.Provider>
  );
};

export const useSeasons = () => {
  const ctx = useContext(SeasonContext);
  if (!ctx) throw new Error("useSeasons must be used within SeasonProvider");
  return ctx;
};
